import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../Layout/Header";
import { BaseUrl } from "../..";
import Footer from "../Layout/Footer";
function Panel1() {
  const [result, setResult] = useState([]);
  const [showName, setShowName] = useState("");
  const [loading, setLoading] = useState(false);
  const { panelAlias } = useParams();
  const API_URL_R = `${BaseUrl}weekly-show-data`;

  const fetchPanelData = async (alias) => {
    setLoading(true);
    try {
      const response = await fetch(API_URL_R, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ panelAlias: alias }),
      });

      const data = await response.json();
      if (data.status === "Success") {
        setResult(data.data.data);
        setShowName(data.data.ShowName);
        // document.title = `${data.data.ShowName} Panel | madhushree.in`;
        // Set Meta Title
        let metaTitle = document.querySelector('meta[name="title"]');
        if (!metaTitle) {
          metaTitle = document.createElement("meta");
          metaTitle.name = "title";
          document.head.appendChild(metaTitle);
        }
        metaTitle.content =
          data.MetaTitle || `${data.ShowName} Panel | madhushree.in`;

        // Set Meta Keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
          metaKeywords = document.createElement("meta");
          metaKeywords.name = "keywords";
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.content =
          data.MetaKeywords || data.ShowName || "Default keywords";

        // Set Meta Description
        let metaDescription = document.querySelector(
          'meta[name="description"]'
        );
        if (!metaDescription) {
          metaDescription = document.createElement("meta");
          metaDescription.name = "description";
          document.head.appendChild(metaDescription);
        }
        metaDescription.content =
          data.MetaDescriptions || data.ShowName || "Default description";
      } else {
        setResult([]);
      }
    } catch (error) {
      console.log(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (panelAlias) {
      fetchPanelData(panelAlias);
    }
  }, [panelAlias]);
  // const pageTitle = `Madhu Shree Morning Panel`;

  return (
    <>
      {/* <Helmet>
        <title>{pageTitle}</title>
      </Helmet> */}
      <Header />
      <div className="layout_table">
        <h6 className="result ms-3">
          <Link to="/">/HOME</Link>
        </h6>
      </div>
      <div className="layout_table">
        <div className="row">
          <div className="col-md-12">
            <h6 className="text_heading">{showName} Panel Chart</h6>
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                </div>
              ) : (
                <table className="panel-chart chart-table" cellpadding="2">
                  {result.length > 0 ? (
                    <>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th colspan="3">Mon</th>
                          <th colspan="3">Tue</th>
                          <th colspan="3">Wed</th>
                          <th colspan="3">Thu</th>
                          <th colspan="3">Fri</th>
                          <th colspan="3">Sat</th>
                          <th colspan="3">Sun</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.map((val, index) => {
                          const days = [
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                            "Sunday",
                          ];

                          const renderDay = (dayData) => {
                            if (!dayData) {
                              return (
                                <>
                                  <td>*</td>
                                  <td>*</td>
                                  <td>*</td>
                                </>
                              );
                            }

                            const open = dayData.open[0] || {};
                            const close = dayData.close[0] || {};

                            return (
                              <>
                                <td
                                  style={{
                                    color: open["i"] === 1 ? "red" : "black",
                                  }}
                                >
                                  {open["1"]} <br />
                                  {open["2"]} <br />
                                  {open["3"]} <br />
                                </td>
                                <td
                                  style={{
                                    color: open["i"] === 1 ? "red" : "black",
                                  }}
                                >
                                  {open["a"]}
                                  {close["a"]}
                                </td>
                                <td
                                  style={{
                                    color: open["i"] === 1 ? "red" : "black",
                                  }}
                                >
                                  {close["1"]} <br />
                                  {close["2"]} <br />
                                  {close["3"]} <br />
                                </td>
                              </>
                            );
                          };
                          return (
                            <tr key={index}>
                              <td>{val.weekRange}</td>
                              {days.map((day) => renderDay(val.days[day]))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="8" className="no-data-text">
                          No Data Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="refresh-button-wrapper">
        <button
          onClick={() => window.location.reload()}
          className="refresh-button"
        >
          Refresh
        </button>
      </div>
      <div class="support-box">
        <p>
          <em>Email for any inquiries Or Support:</em>
        </p>
        <div class="email-button">madhushreeofficia13@gmaiI.com</div>
      </div>
      <Footer />
    </>
  );
}

export default Panel1;
